import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import {
  FiPhone,
  FiMail,
  FiUser,
  FiCheck,
  FiLock,
  FiUnlock,
  FiX,
  FiCheckCircle,
  FiShield,
  FiCalendar,
  FiHome,
} from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { userViewPropertyPost } from "../../../redux/userViewdProperty/UserViewdPropertySlice";
import { userUpdateById } from "../../../redux/athentication/Athentication";
import { propertyUpdate } from "../../../redux/property/PropertySlice";
import { Baseurl } from "../../../config/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import "./PropertyDetailsModel.css";

const PropertyDetailsModel = ({ propertyprop, closePropdet, changeView, actionType = "contact" }) => {
  const { loginData } = useSelector((store) => store.Athentication);
  const dispatch = useDispatch();

  const [reasontobuy, setReasontobuy] = useState("Investment");
  const [dealer, setDealer] = useState(false);
  const [planingtobuy, setPlaningtobuy] = useState("3 months");
  const [homeLoan, sethomeLoan] = useState(false);
  const [siteVisit, setSiteVisit] = useState(false);
  const [agreeToMgh, setAgreeToMgh] = useState(true);

  const [alredyViewed, setAlredyViewed] = useState(true);
  const [tempLoading, setTempLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [singleProperty, setSingleProperty] = useState(propertyprop);

  useEffect(() => {
    let isMounted = true;
    const viewResponseClick = async () => {
      if (!propertyprop?._id || !loginData?._id) {
        if (isMounted) setTempLoading(false);
        return;
      }
      try {
        const formVerifyData = {
          propertyId: propertyprop._id,
          userId: loginData._id,
        };
        const config = {
          headers: { "Content-Type": "application/json" },
        };
        const verifyurl = `${Baseurl}/api/v1/viewed/viewedpropertyverifybyuser`;
        const propertyVerify = await axios.post(
          verifyurl,
          formVerifyData,
          config
        );
        if (isMounted) {
          if (
            propertyVerify.data?.success === true &&
            propertyVerify.data.userViewedProperty?.length > 0
          ) {
            setAlredyViewed(false);
          }
          setTempLoading(false);
        }
      } catch (error) {
        if (isMounted) setTempLoading(false);
      }
    };
    viewResponseClick();
    return () => {
      isMounted = false;
    };
  }, [propertyprop, loginData?._id]);

  useEffect(() => {
    if (propertyprop) {
      setSingleProperty(propertyprop);
    }
  }, [propertyprop]);

  const viewAdvertiserClick = (e) => {
    if (e) e.preventDefault();

    if (!loginData?._id) {
      toast.info("Please log in to contact the advertiser");
      return;
    }
    if (!singleProperty?._id) return;

    setIsSubmitting(true);

    const formdata = {
      userId: loginData._id,
      userName: loginData.name || "",
      userMobile: loginData.mobile || "",
      userOwnerShip: loginData.role || "",
      userEmail: loginData.email || "",
      postUserPackage: loginData.packageType || "",
      propertyId: singleProperty._id,
      visiblePropertyId: singleProperty.propertyID || "",
      propertyName: singleProperty.apartment || "",
      noofBedrooms: singleProperty.noofBedrooms || 0,
      price: singleProperty.visiblePrice || "",
      locality: singleProperty.locality || "",
      city: singleProperty.city || "",
      state: singleProperty.state || "",
      propertyStatus: singleProperty.propertyStatus || "",
      noofviews: 0,
      category: singleProperty.category || "",
      subcategory: singleProperty.subCategory || "",
      postUserId: singleProperty.userId || "",
      postUserName: singleProperty.postUserName || "",
      postUserEmail: singleProperty.postUserEmail || "",
      postUserMobile: singleProperty.postUserMobile || "",
      yourReason: reasontobuy,
      areYouaDealer: dealer,
      planingforBuy: planingtobuy,
      homeloan: homeLoan,
      sitevisit: siteVisit,
      agreeToMgh: agreeToMgh,
    };

    dispatch(userViewPropertyPost(formdata));
    if (typeof changeView === "function") {
      changeView();
    }

    if (singleProperty._id) {
      const propertyFormdata = {
        propertyId: singleProperty._id,
        noofPropertyViewed: (singleProperty.noofPropertyViewed || 0) + 1,
      };
      dispatch(propertyUpdate(propertyFormdata));
    }

    if (loginData._id) {
      const userUpdate = {
        userId: loginData._id,
        creadits: Math.max(0, (loginData.creadits || 1) - 1),
      };
      dispatch(userUpdateById(userUpdate));
    }

    setIsSubmitting(false);
    setAlredyViewed(false);
    toast.success("Advertiser contact details unlocked!");
  };

  const mobileRaw = String(singleProperty?.postUserMobile || "");
  const emailRaw = String(singleProperty?.postUserEmail || "");

  const maskedMobile =
    mobileRaw.length >= 4
      ? `+91 •••••••${mobileRaw.slice(-4)}`
      : "+91 ••••••••••";
  const maskedEmail =
    emailRaw.length >= 4
      ? `••••••${emailRaw.slice(-4)}`
      : "••••••@••••.com";

  const fullMobile = mobileRaw || "9063483711";
  const fullEmail = emailRaw || "info@ewrealty.com";
  const roleName = singleProperty?.postUserPosition
    ? singleProperty.postUserPosition.toUpperCase()
    : "OWNER";
  const advertiserName = singleProperty?.postUserName || "Advertiser";
  const propPrice = singleProperty?.visiblePrice
    ? `₹ ${singleProperty.visiblePrice}`
    : "Price on Request";

  return (
    <div className="mgh-contact-modal-root">
      {/* ================= Header Bar ================= */}
      <div className="mgh-cmodal-header">
        <div className="mgh-cmodal-header-text">
          <h3>
            <FiShield style={{ color: "#ea580c" }} />
            <span>
              {actionType === "phone"
                ? "Get Phone Number"
                : `Contact ${roleName ? roleName.charAt(0) + roleName.slice(1).toLowerCase() : "Advertiser"}`}
            </span>
          </h3>
          <p>
            {alredyViewed
              ? (actionType === "phone"
                ? "Share your details to unlock verified phone number"
                : "Share your preferences to view verified contact details")
              : "Advertiser contact details are unlocked"}
          </p>
        </div>

        {typeof closePropdet === "function" && (
          <button
            type="button"
            className="mgh-cmodal-close-btn"
            onClick={closePropdet}
            aria-label="Close"
          >
            <FiX />
          </button>
        )}
      </div>

      {tempLoading ? (
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <div
            className="spinner-border text-warning"
            role="status"
            style={{ width: "2.5rem", height: "2.5rem", color: "#ea580c" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
          <p
            style={{
              marginTop: "12px",
              color: "#64748b",
              fontWeight: "600",
              fontSize: "13.5px",
            }}
          >
            Verifying contact access...
          </p>
        </div>
      ) : (
        <>
          {/* ================= Property & Advertiser Banner ================= */}
          <div className="mgh-cmodal-banner">
            <div className="mgh-cmodal-advertiser-info">
              <div className="mgh-cmodal-avatar">
                {advertiserName.charAt(0).toUpperCase()}
              </div>
              <div className="mgh-cmodal-advertiser-meta">
                <h4>
                  <span>{advertiserName}</span>
                  <span className="mgh-cmodal-role-pill">{roleName}</span>
                </h4>
                <p className="mgh-cmodal-advertiser-contacts">
                  {alredyViewed ? (
                    <>
                      <FiLock size={13} style={{ color: "#ea580c" }} />
                      <span>{maskedMobile}</span>
                      <span>•</span>
                      <span>{maskedEmail}</span>
                    </>
                  ) : (
                    <>
                      <FiUnlock size={13} style={{ color: "#16a34a" }} />
                      <span>+91 {fullMobile}</span>
                      <span>•</span>
                      <span>{fullEmail}</span>
                    </>
                  )}
                </p>
              </div>
            </div>

            <div className="mgh-cmodal-prop-summary">
              <div className="mgh-cmodal-prop-title">
                {singleProperty?.apartment || "Property"}
              </div>
              <div className="mgh-cmodal-prop-price">{propPrice}</div>
              <p className="mgh-cmodal-prop-sub">
                {singleProperty?.carpetArea ? `${singleProperty.carpetArea} Sq.Ft. • ` : ""}
                {singleProperty?.availabilityStatus || "Available"}
              </p>
            </div>
          </div>

          {/* ================= Modal Body Content ================= */}
          {alredyViewed ? (
            /* ================= Not Viewed: Preference Form ================= */
            <>
              <div className="mgh-cmodal-body">
                <div className="mgh-cmodal-grid">
                  {/* Left Column: Purpose & Buyer Information */}
                  <div className="mgh-cmodal-col">
                    <div className="mgh-cmodal-section-title">
                      <FiUser />
                      <span>Your Information</span>
                    </div>

                    <div className="mgh-cmodal-field">
                      <label className="mgh-cmodal-label">Your reason to buy</label>
                      <div className="mgh-cmodal-pills-row">
                        <button
                          type="button"
                          className={`mgh-cmodal-pill-btn ${reasontobuy === "Investment" ? "active" : ""
                            }`}
                          onClick={() => setReasontobuy("Investment")}
                        >
                          {reasontobuy === "Investment" && <FiCheck size={12} />}
                          <span>Investment</span>
                        </button>
                        <button
                          type="button"
                          className={`mgh-cmodal-pill-btn ${reasontobuy === "Own Business Use" ? "active" : ""
                            }`}
                          onClick={() => setReasontobuy("Own Business Use")}
                        >
                          {reasontobuy === "Own Business Use" && (
                            <FiCheck size={12} />
                          )}
                          <span>Self / Business Use</span>
                        </button>
                      </div>
                    </div>

                    <div className="mgh-cmodal-field">
                      <label className="mgh-cmodal-label">
                        Are you a property dealer?
                      </label>
                      <div className="mgh-cmodal-pills-row">
                        <button
                          type="button"
                          className={`mgh-cmodal-pill-btn ${!dealer ? "active" : ""
                            }`}
                          onClick={() => setDealer(false)}
                        >
                          {!dealer && <FiCheck size={12} />}
                          <span>No, Individual Buyer</span>
                        </button>
                        <button
                          type="button"
                          className={`mgh-cmodal-pill-btn ${dealer ? "active" : ""
                            }`}
                          onClick={() => setDealer(true)}
                        >
                          {dealer && <FiCheck size={12} />}
                          <span>Yes, Property Dealer</span>
                        </button>
                      </div>
                    </div>

                    <div className="mgh-cmodal-field">
                      <label className="mgh-cmodal-label">Your Name</label>
                      <div className="mgh-cmodal-input-wrap">
                        <FiUser className="mgh-cmodal-input-icon" />
                        <input
                          type="text"
                          className="mgh-cmodal-input"
                          placeholder="Your Name"
                          value={loginData?.name || "Verified Buyer"}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="mgh-cmodal-field">
                      <label className="mgh-cmodal-label">Your Mobile</label>
                      <div className="mgh-cmodal-input-wrap">
                        <span className="mgh-cmodal-prefix">+91</span>
                        <input
                          type="text"
                          className="mgh-cmodal-input"
                          placeholder="Mobile number"
                          value={loginData?.mobile || "9063483711"}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="mgh-cmodal-field">
                      <label className="mgh-cmodal-label">Your Email</label>
                      <div className="mgh-cmodal-input-wrap">
                        <FiMail className="mgh-cmodal-input-icon" />
                        <input
                          type="email"
                          className="mgh-cmodal-input"
                          placeholder="Email address"
                          value={loginData?.email || "customer@ewrealty.com"}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  {/* Right Column: Timeline & Value Services */}
                  <div className="mgh-cmodal-col">
                    <div className="mgh-cmodal-section-title">
                      <FiCalendar />
                      <span>Purchase Timeline & Assistance</span>
                    </div>

                    <div className="mgh-cmodal-field">
                      <label className="mgh-cmodal-label">
                        When are you planning to buy?
                      </label>
                      <div className="mgh-cmodal-pills-row">
                        <button
                          type="button"
                          className={`mgh-cmodal-pill-btn ${planingtobuy === "3 months" ? "active" : ""
                            }`}
                          onClick={() => setPlaningtobuy("3 months")}
                        >
                          {planingtobuy === "3 months" && <FiCheck size={12} />}
                          <span>Within 3 Months</span>
                        </button>
                        <button
                          type="button"
                          className={`mgh-cmodal-pill-btn ${planingtobuy === "6 months" ? "active" : ""
                            }`}
                          onClick={() => setPlaningtobuy("6 months")}
                        >
                          {planingtobuy === "6 months" && <FiCheck size={12} />}
                          <span>3 - 6 Months</span>
                        </button>
                        <button
                          type="button"
                          className={`mgh-cmodal-pill-btn ${planingtobuy === "More than 6 months" ? "active" : ""
                            }`}
                          onClick={() => setPlaningtobuy("More than 6 months")}
                        >
                          {planingtobuy === "More than 6 months" && (
                            <FiCheck size={12} />
                          )}
                          <span>After 6 Months</span>
                        </button>
                      </div>
                    </div>

                    <div className="mgh-cmodal-field">
                      <label className="mgh-cmodal-label">
                        Additional Services & Preferences
                      </label>
                      <div className="mgh-cmodal-checkbox-list">
                        <label
                          className={`mgh-cmodal-check-card ${homeLoan ? "active" : ""
                            }`}
                        >
                          <input
                            type="checkbox"
                            checked={homeLoan}
                            onChange={() => sethomeLoan(!homeLoan)}
                          />
                          <span className="mgh-cmodal-check-text">
                            I am interested in Home Loan assistance with lowest interest rates
                          </span>
                        </label>

                        <label
                          className={`mgh-cmodal-check-card ${siteVisit ? "active" : ""
                            }`}
                        >
                          <input
                            type="checkbox"
                            checked={siteVisit}
                            onChange={() => setSiteVisit(!siteVisit)}
                          />
                          <span className="mgh-cmodal-check-text">
                            I want to schedule an in-person Site Visit with the advertiser
                          </span>
                        </label>

                        <label
                          className={`mgh-cmodal-check-card ${agreeToMgh ? "active" : ""
                            }`}
                        >
                          <input
                            type="checkbox"
                            checked={agreeToMgh}
                            onChange={() => setAgreeToMgh(!agreeToMgh)}
                          />
                          <span className="mgh-cmodal-check-text">
                            I agree to receive verified property updates via WhatsApp, SMS, and phone
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ================= Footer CTA ================= */}
              <div className="mgh-cmodal-footer">
                <button
                  type="button"
                  className="mgh-cmodal-submit-btn"
                  onClick={viewAdvertiserClick}
                  disabled={isSubmitting}
                >
                  <FiUnlock size={17} />
                  <span>
                    {isSubmitting
                      ? "Unlocking Details..."
                      : actionType === "phone"
                        ? "Unlock Phone Number"
                        : "View Advertiser Details"}
                  </span>
                </button>
                <p className="mgh-cmodal-disclaimer">
                  By clicking, you accept EwRealty Terms & Conditions • 100% spam-free guarantee
                </p>
              </div>
            </>
          ) : (
            /* ================= Unlocked State View ================= */
            <div className="mgh-cmodal-unlocked-card">
              <div className="mgh-cmodal-success-badge">
                <FiCheckCircle size={16} />
                <span>Advertiser Details Unlocked</span>
              </div>

              <h3 className="mgh-cmodal-unlocked-title">
                Connect Directly with {advertiserName}
              </h3>
              <p className="mgh-cmodal-unlocked-subtitle">
                The {roleName.toLowerCase()} has also been notified of your interest. You can call, WhatsApp, or email directly.
              </p>

              <div className="mgh-cmodal-action-buttons">
                <a
                  href={`tel:${fullMobile}`}
                  className="mgh-cmodal-action-btn mgh-cmodal-call-btn"
                >
                  <FiPhone size={17} />
                  <span>Call +91 {fullMobile}</span>
                </a>

                <a
                  href={`https://wa.me/91${fullMobile}?text=${encodeURIComponent(
                    `Hi ${advertiserName}, I am interested in your property (${singleProperty?.apartment || "Listing"}) listed on EwRealty.`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mgh-cmodal-action-btn mgh-cmodal-wa-btn"
                >
                  <FaWhatsapp size={19} />
                  <span>Chat on WhatsApp</span>
                </a>

                <a
                  href={`mailto:${fullEmail}?subject=${encodeURIComponent(
                    `Inquiry for ${singleProperty?.apartment || "Property"} on EwRealty`
                  )}`}
                  className="mgh-cmodal-action-btn mgh-cmodal-email-btn"
                >
                  <FiMail size={17} />
                  <span>Email Advertiser</span>
                </a>
              </div>

              {typeof closePropdet === "function" && (
                <button
                  type="button"
                  style={{
                    marginTop: "10px",
                    background: "transparent",
                    border: "none",
                    color: "#64748b",
                    fontSize: "13px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                  onClick={closePropdet}
                >
                  Close Window
                </button>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PropertyDetailsModel;
